import styled from "styled-components";
import { Modal } from "react-bootstrap";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 35px 30px 50px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 24px 36px;
  border-radius: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 30px;
    align-items: center;
  }
`;

export const ContentImg = styled.div`
  border-radius: 0 100% 100% 0;
  width: 35%;
  position: relative;
  margin-top: -24px;
  height: fit-content;

  @media (max-width: 768px) {
    width: 55%;
  }
`;

export const Img = styled.img`
  border-radius: 0 0 100% 100%;
  width: 100%;
`;

export const ButtonIcon = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  left: 50%;
  margin: 0;
  padding: 0;
  border: none;

  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;

  & > svg {
    color: ${({ theme }) => theme.colors.blue};
  }

  &:hover {
    background-color: rgba(255, 255, 255, 1);
    transition: 0.3s;
  }
`;

export const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  max-width: 45%;
  width: 100%;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const TitleInfo = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 26px;
  margin: 0;
  font-family: "Mangueira Bold";

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const SubtitleInfo = styled.h2`
  font-size: 18px;
  margin: 0;
  color: ${({ theme }) => theme.colors.secondaryText};

  @media (max-width: 768px) {
    text-align: center;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TextError = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.red};
`;

export const ButtonContainer = styled.button`
  width: 100%;
  padding: 10px 15px;
  display: flex;
  align-items: center;
  border: none;
  justify-content: center;
  border-radius: 5px;
  margin-top: 10px;

  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blue};
  font-family: "Mangueira Bold";

  &:hover {
    opacity: 80%;
  }
`;

export const Text = styled.span`
  font-size: 14px;
  text-align: center;
`;

export const ButtonLink = styled.a`
  color: ${({ theme }) => theme.colors.blue};
  font-family: "Mangueira Bold";
  text-align: center;
`;

export const ModalStyle = styled(Modal)`
  & .modal-content {
    padding: 15px;
  }

  & video {
    aspect-ratio: 16/9;
    width: 100%;
    border: none;
    border-radius: 15px;
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 39px 28px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 18px;
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: column;

  div {
    display: flex;
    place-content: space-between;

    div {
      display: flex;
      flex-direction: column;

      h2 {
        margin: 0;
        color: #0b24fb;
        font-size: 18px;
        font-weight: 400;
      }
      span {
        color: #7a7a7a;
      }
    }
  }

  svg {
    color: ${({ theme }) => theme.colors.darkBlue};
    cursor: pointer;
    margin-left: 10px;
  }

  margin-bottom: 16px;
`;

export const Field = styled.div`
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
`;

export const ContentToken = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 450px;
  width: 100%;
  margin: 0 auto;
  padding: 15px;
  border-top: 1px dashed #d8d8d8;

  #content-buttons {
    flex-direction: column;
    gap: 15px;

    > button {
      width: 100%;
    }
  }
`;

export const TextLabel = styled.span`
  color: #0b24fb;
`;

export const ContentButtons = styled.div`
  display: flex;
  justify-content: space-around;

  button {
    width: 40%;
  }
`;

export const TextTimer = styled.p`
  text-align: center;

  a {
    color: #0000ff;
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ContentField = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 1fr;
  gap: 15px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 2px;
    margin-bottom: 10px;
  }

  & div:first-of-type {
    margin-bottom: 0;
  }
`;
